import { brokerApi, dynamicFormsApi } from '@/api'

export const getMyApplication = (companyId, opportunityId, groupId) =>
  dynamicFormsApi.get(`/api/v1/companies/${companyId}/application/myapplication/${opportunityId}`, {
    headers: {
      'X-Group-Ids': [groupId]
    }
  })
export const getMyApplications = (companyId, groupId) =>
  dynamicFormsApi.get(`/api/v1/companies/${companyId}/application/myapplications`, {
    headers: {
      'X-Group-Ids': [groupId]
    }
  })

export const putUpdateApplication = (companyId, opportunityId, data) => brokerApi.put(`/api/v1/applicationForm/${companyId}/opportunity/${opportunityId}`, data)

export const getOneApplication = (companyId, applications) =>
  dynamicFormsApi.post(`/api/v1/companies/${companyId}/form/oneapplication`, {
    companyId,
    applications
  })

export const postApplicationValues = (companyId, applications, sectionValues, isMasterApplicationUrl) =>
  dynamicFormsApi.post(`/api/v1/companies/${companyId}/fields/values/application`, {
    companyId,
    applications,
    sectionValues,
    isMasterApplicationUrl
  })

export const postFieldValueFile = (companyId, formSectionId, formFieldId, applications, file, isMasterApplicationUrl, config) => {
  const formData = new FormData()

  formData.append('file', file, file.name)
  // multipart has no native shape for a list of objects, so the applications go over as JSON
  formData.append('applications', JSON.stringify(applications))
  formData.append('sectionId', formSectionId)

  if (formFieldId) {
    formData.append('fieldId', formFieldId)
  }
  formData.append('isMasterApplicationUrl', String(isMasterApplicationUrl))

  return dynamicFormsApi.post(`/api/v1/companies/${companyId}/fields/values/application/file`, formData, config)
}

export const attachFieldValueDocument = (companyId, formSectionId, formFieldId, applications, documentId, isMasterApplicationUrl) =>
  dynamicFormsApi.post(`/api/v1/companies/${companyId}/fields/values/application/document`, {
    companyId,
    applications,
    formSectionId,
    formFieldId,
    documentId,
    isMasterApplicationUrl
  })

export const deleteFieldValueFile = (companyId, formSectionId, formFieldId, applications, fileId) =>
  dynamicFormsApi.delete(`/api/v1/companies/${companyId}/fields/values/application/file`, {
    data: { companyId, applications, formSectionId, formFieldId, fileId }
  })

export const postSubmitDynamicFormsApplication = (companyId, productId, applicationIds, documents) =>
  brokerApi.post(`/api/v1/applicationForm/${companyId}/submitDynamicFormApplication/${productId}`, {
    applicationId: applicationIds,
    documents
  })

export const putExpireFile = (companyId, formFieldValueId) => dynamicFormsApi.put(`/api/v1/companies/${companyId}/fields/values/${formFieldValueId}/expire`)

export const getCollaborators = (companyId, opportunityId) => dynamicFormsApi.get(`api/v1/companies/${companyId}/collaborators/${opportunityId}`)

export const inviteCollaborators = (companyId, data) => dynamicFormsApi.post(`api/v1/companies/${companyId}/collaborators/create`, data)

export const inviteCollaboratorsWithEmail = (companyId, data) => dynamicFormsApi.post(`api/v1/companies/${companyId}/collaborators/createwithemail`, data)
